// ##############################
// // // Sessione Scatti styles
// #############################

import {
    drawerWidth,
    drawerMiniWidth,
    transition,
    containerFluid
} from "../../../../assets/jss/material-dashboard-pro-react.jsx";
import {grayColor, successColor} from "../../../../assets/jss/material-dashboard-pro-react";

const sessioneScattiStyle = theme => ({
    wrapper: {
        position: "relative",
        top: "0",
        height: "100vh",
        "&:after": {
            display: "table",
            clear: "both",
            content: '" "'
        }
    },
    mainPanel: {
        transitionProperty: "top, bottom, width",
        transitionDuration: ".2s, .2s, .35s",
        transitionTimingFunction: "linear, linear, ease",
        [theme.breakpoints.up("md")]: {
            width: `calc(100% - ${drawerWidth}px)`
        },
        overflow: "auto",
        position: "relative",
        float: "right",
        ...transition,
        maxHeight: "100%",
        width: "100%",
        overflowScrolling: "touch"
    },
    content: {
        marginTop: "70px",
        padding: "30px 15px",
        minHeight: "calc(100vh - 123px)"
    },
    container: { ...containerFluid },
    map: {
        marginTop: "70px"
    },
    mainPanelSidebarMini: {
        [theme.breakpoints.up("md")]: {
            width: `calc(100% - ${drawerMiniWidth}px)`
        }
    },
    mainPanelWithPerfectScrollbar: {
        overflow: "hidden !important"
    },
    button: {
        minWidth: "auto",
        minHeight: "auto",
        backgroundColor: grayColor,
        color: "#FFFFFF",
        boxShadow:
            "0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12)",
        border: "none",
        borderRadius: "3px",
        position: "relative",
        padding: "12px 30px",
        margin: "10px 1px",
        fontSize: "12px",
        fontWeight: "400",
        textTransform: "uppercase",
        letterSpacing: "0",
        willChange: "box-shadow, transform",
        transition:
            "box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        lineHeight: "1.3",
        textAlign: "center",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        touchAction: "manipulation",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: grayColor,
            color: "#FFFFFF",
            boxShadow:
                "0 14px 26px -12px rgba(153, 153, 153, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(153, 153, 153, 0.2)"
        }
    },
    success: {
        backgroundColor: successColor,
        boxShadow:
            "0 2px 2px 0 rgba(76, 175, 80, 0.14), 0 3px 1px -2px rgba(76, 175, 80, 0.2), 0 1px 5px 0 rgba(76, 175, 80, 0.12)",
        "&:hover": {
            backgroundColor: successColor,
            boxShadow:
                "0 14px 26px -12px rgba(76, 175, 80, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(76, 175, 80, 0.2)"
        }
    },

    rowCel: {
        fontSize: '13px',
        color: '#9a33b1',
        textAlign: "right"
    },
    coupon: {
        color: 'red'
    },
    headerDetailsTable: {
        fontSize: '0.7rem',
        color: '#85c687'
    },
    bodyDetailsTable: {
        fontSize: '0.7rem',
        paddingRight: '5px'
    },
    summary: {
        fontSize: '0.7rem'
    },
    total: {
        fontWeight: 'bold',
        fontSize: '0.7rem'
    },
    couponUsed: {
        color: 'red',
        fontSize: '0.7rem'
    },
    // parent: {
    //     backgroundColor: 'white', display: "flex",  flexWrap: "wrap"
    // },
    // child: {
    //     flex: '1 0 21%',
    //     margin: '5px',
    //     height: '100px',
    //     // backgroundColor: 'blue'
    // },
    // childNew: {
    //     flex: '1 0 21%',
    //     margin: '5px',
    //     height: '100px',
    //     // backgroundColor: 'blue'
    // },
    downloadLabel: {
        fontWeight: '500',
        fontStyle: 'normal',
        fontSize: '12px',
        paddingTop: '30px',
        marginLeft: '20px'
    },

    inputContainer: {
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
    },

    buttonsContainer: {
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '20px'

    },
    tableData: {
        textAlign: "center",
    }


});

export default sessioneScattiStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/layouts/sessioneScattiStyle.jsx